import {Cpu} from './cpu';

/**
 * Created by jmulder on 18/10/16.
 */


export class Club {

  constructor(
      public $key: string,
      public name: string,
      public city: string,
      public url: string,
      public demo: boolean,
      public latitude: number,
      public longitude: number,
      public distributorCode?: number,
      public tenantId?: number
  ) {

  }

  static fromJson({$key, name, city, url, demo, latitude, longitude, distributorCode, tenantId}) {
      return new Club($key, name, city, url, demo, latitude, longitude, distributorCode, tenantId);
  }

  static fromJsonArray(json : any[]) : Club[] {
      return json.map(Club.fromJson);
    }

  static toClub(r:any): Club {

    let field = <Club>({
      $key: r.$key,
      name: r.name,
      city: r.city,
      url: r.url,
      demo: r.demo,
      latitude: r.latitude,
      longitude: r.longitude,
      distributorCode: r.distributorCode ? r.distributorCode : 0,
      tenantId: r.tenantId ? r.tenantId : 0
    });
    return field;
  }

}
